// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__0s4X2","grid":"Delivery_grid__uugco","header":"Delivery_header__WX+jW","goBack":"Delivery_goBack__aAaZ4","container":"Delivery_container__bdOIk"};